window.addEventListener('load', () => {
    document.querySelectorAll('[data-faq-page-title]').forEach((pageTitleElement) => {
        const pageTitle = pageTitleElement.getAttribute('data-faq-page-title');

        if (pageTitle) {
            pageTitleElement.querySelectorAll('[data-dynamic-card-index]').forEach((cardElement) => {
                cardElement.innerHTML = cardElement.innerHTML.replace(/\[PAGE_TITLE\]/g, pageTitle);
            });
        }
    });

});